import { Injectable } from '@angular/core';
import { NavigationService } from '../misc/navigation/navigation.service';
import { HttpService } from '../rest/http-service/http.service';
import { Utils } from '../../../core/helpers/Utils';
import { AppConfigService } from '../misc/app-config/app-config.service';
import { ServiceModule } from '../../service.module';

@Injectable({ providedIn: ServiceModule })
export class AuthService {
    private LOGOUT_URL = '/api/logout';
    constructor(
		private _navigationService: NavigationService,
		private _httpService: HttpService<void>,
		private _appConfigService: AppConfigService
    ) {}

    public isAuthenticated(): boolean {
        if (Utils.isMock()) {
            return true;
        }
        let userInfo = this._appConfigService.getUserInfoModel();
        if (!userInfo) {
            return false;
        }
        return true;
    }
    public getAuthenticatedUsername(): string {
        let userInfo = this._appConfigService.getUserInfoModel();
        return `${userInfo.first_name} ${userInfo.last_name}`;
    }

    public login(redirectPath: string, idp: string) {
        this._navigationService.navigateToLogin(redirectPath, idp);
    }

    public logout() {
        return this._httpService.post(this.LOGOUT_URL).subscribe((idpLogoutUrl) => {
            this._appConfigService.clearUserInfo();
            try {
                new URL(idpLogoutUrl);
            } catch (e) {
                this._navigationService.navigateToLoginPage();
                return;
            }
            this._navigationService.navigateToLogout(idpLogoutUrl);
        });
    }
}
